import svg4everybody from 'svg4everybody';
import '../blocks/section/section';
import '../blocks/col-height/col-height';
import '../blocks/colorbox/colorbox';
import '../blocks/slider/slider';
import '../blocks/burger-btn/burger-btn';
import '../blocks/search/search'
import '../blocks/dropdowns/dropdowns';
import '../blocks/form-control/form-control';
import '../blocks/form-result/form-result';
import '../blocks/col/col';
import '../blocks/placeholder/placeholder';
import '../blocks/tooltip/tooltip';
import '../blocks/off-canvas/off-canvas';

$(() => {
	svg4everybody();
});



// WEBPACK FOOTER //
// ./_dev/scripts/app.js